module.exports = __webpack_public_path__ + "static/media/picture-(268).ce08d9bd.JPG";